import { pricingRuleIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const updatePricingRule = {
  name: "updatePricingRule" as const,

  input: z.object({
    pricingRuleId: pricingRuleIdFormat.schema,
    name: z.string(),
    active: z.boolean().optional(),
    productIds: z.array(productIdFormat.schema),
    thresholds: z
      .array(
        z.object({
          quantity: z.number().int(),
          price: z.number().min(0),
          currency: z.string(),
        }),
      )
      .optional(),
  }),

  output: z.object({ success: z.boolean() }),
};
